import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

export default function StoragePopUp({ open, setOpen, message }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "15px",
        }}
      >
        <DialogTitle style={{ fontSize: "1.2rem", textAlign: "center" }}>
          Limit Exceeded
        </DialogTitle>

        <Typography
          variant="body2"
          style={{
            color: "red",
            textAlign: "center",
            marginBottom: "20px",
            whiteSpace: "pre-line",
          }}
        >
          {message || "Data and media limit exceeded.\nPlease contact administrator."}
        </Typography>

        {/* <div
          className="col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <button
            className="btn btn__secondary mt-10"
            type="button"
            onClick={handleClose}
            style={{ padding: "3px 12px", fontSize: "1rem" }}
          >
            OK
          </button>
        </div> */}
      </DialogContent>
    </Dialog>
  );
}
